import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Human from "../../Icons/Human";

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    boxSizing: 'border-box',
    background: '#F2F6F9',
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    position: "relative",
    width: "calc(100% - 62px)",
  },

  heading: {
    fontSize: "14px",
    color: "#000000",
  },

  desc: {
    fontSize: "11px",
    color: "#71737B",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%",
  },
});

class KeymanAttribute extends React.Component {
  render() {
    const { classes, item } = this.props;

    return (
      <div className={classes.root} style={this.props.style}>
        <div className={classes.icon}>
          <Human width={20} height={20} color="#7C8297" />
        </div>
        <div className={classes.textContainer}>
          <Typography className={classes.heading}>
            {item.name ? item.name : item.company} 様
          </Typography>
          <Typography className={classes.desc}>
            {!item.company && !item.position
              ? ""
              : `${item.company ? item.company + " " : ""}${item.position ? item.position : ""
              }`}
          </Typography>
        </div>
      </div>
    )
  }
}

KeymanAttribute.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default withStyles(styles)(KeymanAttribute);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/parts/KeymanAttribute.jsx